import React from "react";
import { Row } from "react-bootstrap";
import { Select } from "../../../genericComponents";
import { pensionFormNames } from "../models/pensionFormNames";
import { required } from "../models/required";
import { reasonsForRequest } from "../models/selects";

function PensionRegister1() {
  return (
    <Row>
      <Select
        label="Qual o motivo do pedido?"
        name={pensionFormNames.requestReason}
        required={required.default}
        placeholder="Selecione o motivo do pedido"
        options={reasonsForRequest.map((item) => ({
          label: item,
          value: item,
        }))}
      />
    </Row>
  );
}
export default React.memo(PensionRegister1);
